export default function doesExistInArrayOfObj(data, id) {
  const object = data.find(e => e.integrationId === id);
  return object;
}
